// extracted by mini-css-extract-plugin
module.exports = {"chosenCategoryGrid":"ChosenCategoryGrid_chosenCategoryGrid__1z6Nt","ViewedSectionSecondary__3videos":"ChosenCategoryGrid_ViewedSectionSecondary__3videos__2v5bF"};